<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备配置
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="add">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="seefrom.device_name"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable apiUrl="operation/configuration/findAll" :parent="self" :config="config" :other="other" ref="deviceConfig" :height="400">
            <template slot="last">
              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-link>
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)">删除</el-link>
                  <el-link icon="iconfont iconadd" type="text" size="small" @click="concateInstruction(scope.$index, scope.row)">关联指令</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog class="editDialog" title="设备配置编辑" :visible.sync="editDialogForm">
          <el-form :model="addEquipment" ref="addEquipment" :rules="rules">
            <el-form-item label="设备名称" prop="device_name">
              <!-- <el-input placeholder="请输入设备名称" v-model="addEquipment.device_name" readonly></el-input> -->
              <!-- <el-select placeholder="请选择设备名称" v-model="addEquipment.device_name">
                <el-option
                  v-for="item in DeviceNames"
                  :key="item.id"
                  :value="item.id"
                  :label="item.deviceName"
                ></el-option>
              </el-select> -->
              <el-select v-if="form1.device_id" v-model="form1.device_id" disabled="true">
                <el-option :label="form1.device_name" :value="form1.device_id"></el-option>
              </el-select>
              <el-button v-else type="text" @click="dialog">点击打开设备列表</el-button>
            </el-form-item>
            <el-form-item label="配置项名称" prop="name">
              <el-input placeholder="请输入配置项名称" v-model.trim="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="配置项标识" prop="mark">
              <el-input placeholder="请输入配置项标识" v-model.trim="addEquipment.mark"></el-input>
            </el-form-item>
            <el-form-item label="配置值" prop="value">
              <el-input placeholder="请输入配置值" v-model.trim="addEquipment.value"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="cancel">取消</el-button>
            <el-button class="confirmButton" @click="Confirm">确定</el-button>
          </div>
        </el-dialog>

        <!-- 关联指令 -->
        <el-dialog class="instructionDialog" title="关联指令" :visible.sync="concatDialogForm">
          <el-form :model="instruction">
            <el-form-item label="名称">
              <el-select class="init_input" placeholder="请选择名称" v-model="instruction.name" @change="getInstruction">
                <el-option v-for="i in option1" :key="i.id" :label="i.name" :value="i.name"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="指令名称">
              <el-select
                class="init_input"
                placeholder="请选择指令名称"
                v-model="instruction.serviceName"
                @change="getParameter"
              >
                <el-option
                  v-for="item in option2"
                  :key="item.id"
                  :label="item.serviceName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="参数配置">
              <div v-for="a in Parameter" :key="a.id">
                <el-col :span="11">
                  <el-form-item label="名称">
                    <el-input class="update_input" v-model="a.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="选择参数">
                    <!-- <el-input class="update_input" v-model="a.value"></el-input> -->
                    <el-button class="update_input" :type="a.connect?'primary':'default'" :plain="a.connect?false:true" size="small" @click="fConnect(a)">{{a.connect?'已选中':'未选择'}}</el-button>
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="concatDialogForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="选择设备" :visible.sync="dialogVisible" width="80%">
      <div class="tableWapper deviceTable">
        <div class="tablehead">
          <div>
            <el-form ref="searchForm_jsgl">
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="seefrom2.deviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input placeholder="请输入设备编码" v-model="seefrom2.device_mark"></el-input>
              </el-form-item>
            </el-form>

          </div>
          <div class="normalNav zaddBtn">
            <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
            <button class="OrangeSmBtn" @click="reset">重置</button>
          </div>
        </div>
        <el-table :data="tableData2" style="width: 100%" class="stripeTable" ref="Table">
          <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config2" :key='prop.toString()'>
          </el-table-column>
          <el-table-column label="操作" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination v-if="flagshow" layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal2">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        device_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入配置项名称', trigger: 'blur' }],
        mark: [{ required: true, message: '请输入配置项标识', trigger: 'blur' }],
        value: [{ required: true, message: '请输入配置值', trigger: 'blur' }],
      },
      option1: [],
      option2: [],
      Parameter: [],
      tabName: 'jsgl',
      loading: true,
      form_jsgl: {},
      showTable: true,
      other: {},
      items: [],
      editDialogForm: false,
      concatDialogForm: false,
      instruction: {
        name: '',
        serviceType: '',
        serviceName: '',
        instructionName: '',
      },
      seefrom: {
        device_name: '',
      },
      addEquipment: {
        device_name: '',
        name: '',
        mark: '',
        value: '',
      },
      DeviceNames: [],
      statuss: '',
      id: '',
      configId: '',
      aParams: [],

      flagshow: true,
      dialogVisible: false,
      pagesize: 3,
      nTotal2: 0,
      currentPage: 1,
      seefrom2: {
        deviceName: '',
        device_mark: '',
      },
      tableData2: [],
      form1: {},
      config2: [
        {
          prop: 'deviceName',
          label: '设备名称',
        },
        {
          prop: 'device_mark',
          label: '设备编码',
        },
        {
          prop: 'region',
          label: '所属区域',
        },
        {
          prop: 'model',
          label: '设备型号',
        },
        {
          prop: 'factory',
          label: '生产厂商',
        },
        {
          prop: 'deviceStatusName',
          label: '设备状态',
        },
        {
          prop: 'systemName',
          label: '应用系统',
        },
      ],
    }
  },
  watch: {
    dialogVisible() {
      this.getTableList()
    },
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'device_name',
          label: '设备名称',
        },
        {
          prop: 'name',
          label: '配置项名称',
        },
        {
          prop: 'mark',
          label: '配置项标识',
        },
        {
          prop: 'value',
          label: '配置值',
        },
      ]
    },
    dt() {
      return dt.map(({ label }) => label)
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom
      this.$refs.deviceConfig.pageToOne()
      this.$nextTick(this.$refs.deviceConfig.getData)
    },
    //重置
    reset() {
      this.seefrom.device_name = ''
    },
    //关联指令
    concateInstruction(index, row) {
      this.instruction.serviceType = ''
      this.instruction.serviceName = ''
      this.Parameter = []
      this.concatDialogForm = true
      this.configId = row.id
      this.$axiosget('manager/devicetype/servicetype', {
        params: {
          deviceType: row.device_type,
        },
      }).then((res) => {
        this.option1 = res.data.data
      })
    },
    //获取服务名称
    getInstruction(type) {
      // var cId = "";
      // //console.log(this.option1);
      // this.option1.forEach(item => {
      //   if (type == item.serviceType) {
      //     cId = item.id;
      //   }
      // });
      // //console.log(cId);
      // this.$axiosget("manager/devicetype/servicename", {
      //   params: {
      //     serviceType: this.instruction.serviceType,
      //     id: cId
      //   }
      // }).then(res => {
      //   this.option2 = res.data.data;
      // });
      //清空
      this.Parameter = []
      this.option1.forEach((item) => {
        if (type === item.name) {
          this.instruction.serviceType = item.serviceType
          this.instruction.serviceName = item.serviceName
          this.instruction.id = item.id
        }
      })
      this.$axiosget('manager/devicetype/commandname', {
        params: {
          id: this.instruction.id,
        },
      }).then((res) => {
        this.Parameter = res.data.data
      })
      if (this.Parameter.status === 0) {
        this.parameter_value = true
      } else {
        this.parameter_value = false
      }
      //console.log(this.parameter_value,"是否可以修改")
    },
    //获取参数
    // getParameter(val) {
    //   this.Parameter = [];
    //   let instructionId = val || this.instruction.serviceName;
    //   let temp = this.option2.find(it => it.id === instructionId);
    //   // //console.log(val,this.instruction.serviceName,temp)
    //   if (temp) {
    //     this.instruction.instructionName = temp.serviceName;
    //   }

    //   this.$axiosget("manager/devicetype/commandname", {
    //     params: {
    //       id: this.instruction.serviceName
    //     }
    //   }).then(res => {
    //     this.Parameter = res.data.data;
    //   });
    // },
    //选择参数
    fConnect(val) {
      let list = val
      this.$set(list, 'connect', list.connect ? !list.connect : true)
      let connect = list.connect
      if (connect) {
        this.aParams.push(list)
      } else {
        let i = this.aParams.findIndex((it) => val.id === it.id)
        this.aParams.splice(i, 1)
      }
    },
    //关联指令--确认
    submitForm() {
      //console.log(this.aParams)
      // var formData = new FormData();
      // formData.append("configurationId", this.configId);
      // formData.append("serviceName", this.instruction.instructionName);
      // formData.append("commandName", this.aParams[0].valueName);
      // formData.append("argName", this.instruction.serviceType);

      if (this.aParams.length < 1) {
        this.$notify({
          title: '至少选择一个参数',
          type: 'warning',
        })
        return
      } else if (this.aParams.length > 1) {
        this.$notify({
          title: '只能选择一个参数',
          type: 'warning',
        })
        return
      } else {
        this.$axiosget('operation/configuration/relateCommand', {
          params: {
            configurationId: this.configId,
            serviceName: this.instruction.serviceType,
            commandName: this.instruction.instructionName,
            argName: this.aParams[0].valueName,
          },
        }).then((res) => {
          this.concatDialogForm = false
          this.$message.success('关联指令成功！')
        })
      }
    },
    //新增
    add() {
      this.statuss = 0
      this.editDialogForm = true
      this.addEquipment = {
        device_name: '',
        name: '',
        mark: '',
        value: '',
      }
      if (this.$refs['addEquipment']) this.$refs['addEquipment'].clearValidate()
    },
    //编辑
    edit(index, row) {
      this.statuss = 1
      this.editDialogForm = true
      this.addEquipment.device_name = row.device_id
      this.addEquipment.name = row.name
      this.addEquipment.mark = row.mark
      this.addEquipment.value = row.value
      this.id = row.id
      if (this.$refs['addEquipment']) this.$refs['addEquipment'].clearValidate()
    },
    //确认
    Confirm() {
      this.$refs.addEquipment.validate((valid) => {
        if (valid) {
          if (this.statuss === 0) {
            this.$axiospost('operation/configuration/save', {
              device_id: this.addEquipment.device_name,
              name: this.addEquipment.name,
              mark: this.addEquipment.mark,
              value: this.addEquipment.value,
            }).then((res) => {
              this.editDialogForm = false
              this.subSeefrom()
              this.$message.success('保存成功！')
            })
          } else if (this.statuss === 1) {
            //console.log(this.addEquipment.device_name);
            //console.log(this.DeviceNames);
            this.$axiospost('operation/configuration/save', {
              id: this.id,
              device_id: this.addEquipment.device_name,
              name: this.addEquipment.name,
              mark: this.addEquipment.mark,
              value: this.addEquipment.value,
            }).then((res) => {
              this.editDialogForm = false
              this.subSeefrom()
              this.$message.success('保存成功！')
            })
          }
        } else {
          this.$message.warning('请输入必填项！')
        }
      })
      this.form1 = {
        device_id: '',
        device_name: '',
      }
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm('是否删除该设备配置?', '删除操作', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      })
        .then(() => {
          this.$axiosdelete('operation/configuration/delete', {
            params: {
              id: row.id,
            },
          }).then((res) => {
            this.subSeefrom()
            this.$message.success('删除成功！')
          })
        })
        .catch(() => {})
    },
    dialog() {
      this.dialogVisible = true
    },
    getTableList() {
      this.$axiosget('operation/device/list', {
        params: { pageSize: 10, pageNum: this.currentPage, ...this.seefrom },
      }).then((res) => {
        this.tableData2 = res.data.data.deviceList
        this.nTotal2 = res.data.data.total
        this.flagshow = true
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableList()
    },
    subSeefrom() {
      this.flagshow = false
      this.getTableList()
    },
    reset() {
      this.seefrom.deviceName = ''
      this.seefrom.device_mark = ''
    },
    handleClick(row) {
      this.dialogVisible = false
      this.form1.device_id = row.deviceId
      this.form1.device_name = row.deviceName
      // this.$refs.add.$forceUpdate()
    },
    cancel() {
      this.editDialogForm = false
      this.form1 = {
        device_id: '',
        device_name: '',
      }
    },
  },
  created() {
    this.$axiosget('operation/device/Trelist').then((res) => {
      //console.log(123);
      //console.log(res);
      this.DeviceNames = res.data.data
    })
  },
}
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.instructionDialog {
  .el-dialog {
    width: 586px;
  }
  .el-form-item {
    margin-top: 10px;
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #ccc;
    width: 138px;
    text-align: right;
  }
  .el-dialog__header {
    border-bottom: 1px solid #2d374d;
  }
  .el-dialog__body {
    padding-top: 45px;
  }
  .el-dialog__footer {
    padding-right: 116px;
    margin-top: 23px;
  }
  .el-dialog__title {
    border-bottom: 2px solid #35b9f7;
    font-size: 16px;
    display: inline-block;
    height: 52px;
    line-height: 52px;
    position: relative;
    top: -20px;
  }
  .el-input__inner {
    border: 1px solid #3d4963;
    border-radius: 0;
  }
  .init_input {
    width: 310px;
  }
  .update_input {
    margin-left: 70px;
    width: 200px;
  }
}
.tablehead {
  display: flex;
  justify-content: space-between;
  .el-form {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/deviceConfig.vue